/** 运营中心-专线调度 */
<template>
  <div id="dispatch">
    <el-dialog :title="viewTitle" :visible.sync="viewVisible" width="40%" append-to-body>
      <el-table :data="viewData" :max-height="575" style="width: 100%" border>
        <el-table-column prop="xianlu" width="400" label="参与线路">
        </el-table-column>
        <el-table-column prop="banci" label="已排班次">
          <template slot-scope="{ row }">
            <span>
              {{ row.banci }}
              <el-tag v-show="row.sameShift" type="success" effect="plain">相同班次</el-tag>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="dispatch-left" ref="dispatchLeft">
      <!--待指派订单-->
      <div class="dispatch-assign" ref="dispatchLeftTop">
        <custom-table ref="customTable" :customOptions="customOptions" :selectionNO="selectionNO"
                      selectionKey="organizationId" @onRowClick="onRowClick" :selectionRow.sync="selectionRow"
                      :loadmoreSwitch="true"
                      :columns="customOptions.params.status == '5' ? columns : columnsed"
                      layout="total, prev, pager, next"
                      :maxHeight="customOptions.params.status == '5' ? 400 : 688">
          <div slot="search-top-left">
            <el-tabs v-model="customOptions.params.status" @tab-click="statusChange">
              <el-tab-pane name="5">
                <span slot="label"><i class="el-icon-s-order" style="margin-right:4px"></i>实时订单池</span>
              </el-tab-pane>
              <el-tab-pane name="10">
                <span slot="label"><i class="el-icon-finished" style="margin-right:4px"></i>已指派订单</span>
              </el-tab-pane>
            </el-tabs>
            <div style="padding-top: 10px" v-if="customOptions.params.status == '5'">
              <el-select clearable v-model="sortValue" filterable placeholder="请选择排序" @change="sortFn"
                         style="width: 130px">
                <el-option v-for="val in sortArr" :key="val.id" :value="val.id" :label="val.name">
                </el-option>
              </el-select>
              <el-select v-if="mixinUserInfo.organizationType == 1" style="margin-left: 10px;width:150px" clearable
                         v-model="customOptions.params.organizationId" filterable placeholder="全部机构名称"
                         @change="$refs.customTable.listFn()">
                <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
                </el-option>
              </el-select>
              <el-input style="width: 150px; margin-left: 10px" v-model="customOptions.params.lineName"
                        placeholder="搜索出发地/目的地" maxlength="64"></el-input>
              <el-input style="width: 150px; margin-left: 10px" v-model="customOptions.params.customerPhone"
                        placeholder="搜索乘客手机号" maxlength="20"></el-input>
              <div style="margin-left: 10px; display: inline-block">
                <el-button type="primary" @click="queryFn">查询</el-button>
                <el-button @click="resetFn">重置</el-button>
              </div>
            </div>
            <div v-else style="display: inline-block;position: absolute;right: 110px;top:42px; ">
              <span class="util-remark">以下订单还未开始行程 </span>
            </div>
            <div class="dispatch-left-line custom-switch" style="padding-top: 18px"
                 v-if="customOptions.params.status == '5'">
              <el-tooltip effect="light" placement="top">
                <i class="el-icon-question util-remark" style="font-size: 15px; padding-right: 6px"></i>
                <div slot="content" style="line-height: 1.6">
                  <p style="font-size: 14px; font-weight: 600">
                    标准模式 - 自动派单说明
                  </p>
                  <p>1.订单所属的班次上，必须设置值班车辆，否则无法自动派单</p>
                  <p>2.订单将按班次上的绑定顺序，依次派出</p>
                  <p>3.车辆有余座时，无论是否在线，都会收到派单</p>
                  <p style="font-size: 14px; font-weight: 600; padding-top: 10px">
                    自由派单 - 自动派单说明
                  </p>
                  <p>1.订单所属的线路上，必须设置值班车辆，否则无法自动派单</p>
                  <p>
                    2.订单优先派给有相同班次的车辆，然后才根据顺序派给下一辆车
                  </p>
                  <!-- <p>3.车辆余座充足、司机端在线时才会收到派单</p> -->
                  <p>3.车辆余座充足才会收到派单</p>
                </div>
              </el-tooltip>
              <span class="util-remark">订单按线路/班次的值班车辆自动派出，未自动派出的请人工派单</span>
              <div style="margin-left:36px;font-weight: normal;">
                <span>实时刷新</span>
                <el-switch v-model="autoRefresh" :active-value="1" :inactive-value="2" @change="autoRefreshChange"/>
              </div>
            </div>
          </div>

          <template slot-scope="{ item, row }">
            <template v-if="item.prop == 'assignMethod'">
              <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
              <span style="margin-left: 6px"></span>
              乘客{{ row.passengerNum }}人
              {{ row[item.prop] | filterConst("ORDERASSIGNMETHOD") }}
            </template>
            <template v-else-if="item.prop == 'lineName'">
              <el-tag :type="row.schedulingType == 1 ? 'success' : row.schedulingType == 3 ? 'danger' : ''"
                      effect="plain">
                {{ row.schedulingType | filterConst("SCHELINGTYPE", "sort") }}
              </el-tag>
              {{ row.startStationName }} - {{ row.endStationName }}
              {{ row.schedulingTime | filterTime("MM-DD") }}
              {{ row.startLineTime }} - {{ row.endLineTime }}
            </template>
            <template v-else-if="item.prop == 'customerPhone' && customOptions.params.status == '5'">
              <el-popover placement="top" v-model="visibleCustomerPhone" @hide="customerPhone = null">
                <div style="display: flex;align-items: center;">
                  <div class="redcheck">手机号码</div>
                  <el-input v-model="customerPhone" style="width:120px;margin: 0 15px;" maxlength="11"
                            @input="customerPhone = customerPhone.replace(/[^\d]/g, '').replace(/^0/g, '')"/>
                  <el-button type="primary" size="mini" :disabled="!customerPhone"
                             @click="setCustomerPhone(row)">保存
                  </el-button>
                </div>
                <span slot="reference" @click.stop="customerPhone = row.customerPhone"
                      style="color:#409EFF;cursor: pointer;">
                  {{ row.customerPhone }}
                </span>
              </el-popover>
            </template>
            <template v-else-if="item.prop == 'assignTime' || item.prop == 'created'">{{ row[item.prop] | filterTime }}
            </template>
            <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
          </template>
          <template v-if="customOptions.params.status == '5'" slot="table-operation">
            <el-table-column label="操作" width="60" fixed="right" header-align="center">
              <div slot-scope="{ row }" class="custom-action-operating">
<!--                <el-button type="text" @click.stop="showOrderDetail(row)">详情</el-button>-->
                <el-button type="text" @click.stop="refund(row)">退票</el-button>
              </div>
            </el-table-column>
          </template>
<!--          <template v-else slot="table-operation">-->
<!--            <el-table-column label="操作" width="60" fixed="right" header-align="center">-->
<!--              <div slot-scope="{ row }" class="custom-action-operating">-->
<!--                <el-button type="text" @click.stop="showOrderDetail(row)">详情</el-button>-->
<!--              </div>-->
<!--            </el-table-column>-->
<!--          </template>-->
        </custom-table>
      </div>

      <!--车辆-->
      <div class="dispatch-vehicle" v-if="visible">
        <div class="dialog-top" ref="dialogTop" style="position: relative">
          <h2>请选择要指派的车辆</h2>
          <span class="util-remark" style="position: absolute; right: 0px">地图只展示在线车辆</span>
        </div>
        <div class="dialog-table">
          <div style="padding-top: 6px" ref="dialogTopSearch">
            <el-select style="width: 100px" v-model="online" placeholder="是否在线" @change="tabClick"
                       :disabled="tabClickStatus" clearable>
              <el-option label="在线" :value="1"></el-option>
              <el-option label="下线" :value="2"></el-option>
            </el-select>
            <el-select style="width: 100px; margin-left: 10px" v-model="vehicleSeat" placeholder="座位数量"
                       @change="tabClick"
                       :disabled="tabClickStatus" clearable>
              <el-option v-for="item in $const.SEATNUMBER" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <el-input style="width: 110px; margin-left: 10px" v-model="licenseNo" placeholder="搜索车辆号牌"
                      maxlength="64"></el-input>
            <el-input style="width: 110px; margin-left: 10px" v-model="driverName" placeholder="搜索值班司机"
                      maxlength="64"></el-input>
            <div style="margin-left: 10px; display: inline-block">
              <el-button type="primary" @click="tabClick">查询</el-button>
              <el-button @click="tabResetFn">重置</el-button>
            </div>
            <div class="flex-center" style="float: right">
              <el-button type="primary" :loading="dispatchLoading" @click="dispatchClick">选择</el-button>
              <el-button @click="closeClick">关闭</el-button>
            </div>
          </div>
          <el-table border ref="tableList" @row-click="chooseClick" :data="table.content"
                    :row-class-name="tableRowClassName" v-el-table-infinite-scroll="vInfiniteScroll"
                    :height="tableHeight ? tableHeight : 'auto'" style="width: 100%; margin-top: 8px"
                    v-loading="loading">
            <el-table-column label="机构名称" min-width="100" show-overflow-tooltip prop="organizationName"
                             v-if="mixinUserInfo.organizationType == 1">
            </el-table-column>
            <el-table-column label="车辆号牌" min-width="120" show-overflow-tooltip prop="licenseNo">
              <template slot-scope="{ row }">
                <div style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 4px;"
                     :style="{ background: row.status == 2 ? '#999' : '#0080009e' }"></div>
                <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="座位数" min-width="100" show-overflow-tooltip prop="vehicleSeat">
              <template slot-scope="{ row }">
                {{ row.vehicleSeat }}座
              </template>
            </el-table-column>
            <el-table-column label="值班司机" show-overflow-tooltip min-width="110" prop="driverName">
              <template slot-scope="{ row }">
                {{ row.driverName ? row.driverName : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="已排班数" min-width="100" show-overflow-tooltip prop="schedulingCount">
              <template slot-scope="{ row }">
                <span v-if="row.schedulingCount" style="color: #0066ff;cursor: pointer;text-decoration: underline;"
                      @click.stop="lineVehicleListView(row)">
                  {{ row.schedulingCount }}
                  <el-tag v-show="row.sameShift" type="success" effect="plain">有相同班次
                  </el-tag>
                </span>
                <span v-else>空闲</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" min-width="65" align="center" label="操作">
              <template slot-scope="{ row }">
                <div style="padding: 0" class="custom-action">
                  <span v-if="row.seatStatus == 1 || row.seatStatus == 2" style="font-size: 14px; color: #999">
                    {{
                      row.seatStatus == 1 ? "座位已满" : row.seatStatus == 2 ? "所选车辆座位不满足，请选择其他车辆" : ""
                    }}
                  </span>
                  <i class="iconfont" :class="vehicleId == row.vehicleId ? ' icon-checked' : ' icon-choose'" v-else></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="dispatch-map-wrapper">
      <div class="dispatch-map-header">
        <span class="dispatch-map-title"><i class="el-icon-map-location"></i>实时地图</span>
        <span class="dispatch-map-hint">仅显示在线车辆位置</span>
      </div>
      <div id="dispatch-map"></div>
    </div>
    <el-dialog title="退票说明" :visible.sync="refundState" width="330px"
               @close="isCustomRule = false; refundFee = null">
      <div :class="{ 'text-disabled': isCustomRule }">
        <div class="cancel-money" v-for="(       item, index       ) in        refundRules       " :key="index">
          {{ index + 1 }}.检票/接人时间{{ item.timeNum }}
          {{ item.timeType == 1 ? "小时" : "分钟" }}内办理退票的，按支付金额{{ item.refundFee }}%收取退票费
        </div>
        <div class="cancel-money" style="padding-top: 20px">
          <div class="cancel-money-title">票面金额</div>
          <div class="util-money">￥{{ refundFeeObj.orderFee }}</div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">实付金额</div>
          <div>
            <span v-if="refundFeeObj.couponFee">优惠券-￥{{ refundFeeObj.couponFee }}</span>
            <span class="util-money">￥{{ refundFeeObj.realFee }}</span>
          </div>
        </div>

        <div class="cancel-money">
          <div class="cancel-money-title">退票费用</div>
          <div>
            <span v-if="refundFeeObj.refundProportion">退票费率{{ refundFeeObj.refundProportion }}%</span>
            <span class="util-money">￥{{ refundFeeObj.retreatFee }}</span>
          </div>
        </div>
        <div class="cancel-money">
          <div class="cancel-money-title">实际退款</div>
          <div class="cancel-money-money util-money">
            ￥{{ refundFeeObj.refundFee }}
          </div>
        </div>
      </div>

      <hr style="margin:20px 0">

      <div>
        <div style="display:flex;align-items:center;margin-bottom:10px">
          <el-checkbox v-model="isCustomRule"></el-checkbox>
          <p @click=" isCustomRule = !isCustomRule" style="cursor: pointer;margin-left:10px">自定义退票手续费</p>
        </div>
        <el-input v-model="refundFee" placeholder="请输入要扣除的费用" :disabled="!isCustomRule"
                  @input="() => refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')"></el-input>
        <p style="margin-top:10px;font-size: 14px;color:red">注意：手续费不能大于实际支付金额，可输入0</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click=" refundState = false">取 消</el-button>
      </span>
    </el-dialog>
    
    <!-- 订单详情抽屉 -->
    <order-detail-drawer :show.sync="orderDetailVisible" :order="currentOrderDetail" />
  </div>
</template>

<script>
import AMap from "AMap";
import {mapGetters} from "vuex";
import elTableInfiniteScroll from "el-table-infinite-scroll";
import OrderDetailDrawer from "@/components/orderDetailDrawer/orderDetailDrawer.vue";
// import { delete } from 'vue/types/umd';

export default {
  name: "dispatch",
  components: {
    OrderDetailDrawer
  },
  directives: {
    "el-table-infinite-scroll": elTableInfiniteScroll,
  },
  computed: {
    noMore() {
      return (
          this.table.total !== 0 && this.table.content.length == this.table.total
      );
    },
    ...mapGetters({
      messageGetter: "messageGetter",
    }),
  },
  data() {
    return {
      // 订单详情抽屉
      orderDetailVisible: false,
      currentOrderDetail: {},
      
      autoRefresh: 1,
      visibleCustomerPhone: false,
      customerPhone: null,
      next: false,
      // 排班列表
      viewTitle: null,
      viewVisible: false,
      viewData: [],
      // 选择订单的班次集合
      shiftList: [],
      // 复选框集合
      selectionRow: [],
      // 排他机构ID
      selectionNO: null,

      isCustomRule: false,
      refundFee: null,

      refundRules: [],
      refundFeeObj: {},
      refundState: false,
      sortArr: [
        {
          id: 0,
          name: "出发时间倒序",
        },
        {
          id: 1,
          name: "出发时间顺序",
        },
        {
          id: 2,
          name: "下单时间倒序",
        },
        {
          id: 3,
          name: "下单时间顺序",
        },
      ],
      sortValue: 1,
      tableHeight: 0,
      timer: "",
      tableRowIndex: "",
      online: null,
      vehicleSeat: null,
      driverName: null,
      licenseNo: null,
      tabClickStatus: false,
      // 地图实例
      map: null,
      // 覆盖物集合
      amap: {
        // 车辆标记
        vehicleMarker: [],
        // 订单标记数组
        markerBeginList: [],
        markerEndList: [],
      },
      // 配置项
      customOptions: {
        // 复选框
        selection: true,
        // 请求的列表url
        url: "/api/v1/manage/order/dispatch",
        params: {
          status: "5",
          page: 1, // 页数
          size: 10, // 每页条数
          organizationId: null,
          lineName: null,
          customerPhone: null,
          startLineTimeSort: 1,
        },
      },
      // 表头
      columns: [
        {prop: "organizationName", label: "机构名称", width: 120},
        {prop: "lineName", label: "线路/班次", minWidth: 270},
        {prop: "customerPhone", label: "乘客联系电话", width: 120},
        {prop: "passengerNum", label: "人数", width: 50, align: "center"},
        {prop: "created", label: "下单时间", width: 130},
        {prop: "remark", label: "备注", width: 80},
      ],
      // 表头
      columnsed: [
        {prop: "organizationName", label: "机构名称", width: 120},
        {prop: "lineName", label: "线路/班次", minWidth: 220},
        {prop: "customerPhone", label: "乘客联系电话", width: 120},
        {prop: "assignMethod", label: "指派信息", width: 250},
        {prop: "assignTime", label: "指派时间", width: 130},
      ],
      // 变量
      visible: false,
      // 选中的订单机构id
      organizationId: null,
      // 选中的订单id数组
      ids: [],
      // 选中的司机id
      driverId: "",
      // 选中的车辆id
      vehicleId: "",
      // 线路信息
      lineInfo: {},
      // 页数
      page: 1,
      // 每页条数
      size: 300, // TODO 后台未做分页
      // 无限加载loading
      loading: false,
      // 车辆列表
      table: {
        content: [],
        total: 0,
      },
      dispatchLoading: false
    };
  },
  watch: {
    // 监听消息
    messageGetter(val) {
      switch (val.msg) {
        case "gps":
          if (val.data && val.data.licenseNo) {
            if (
                this.mixinUserInfo.organizationType == 1 ||
                (this.mixinUserInfo.organizationType == 2 &&
                    val.data.organizationId == this.mixinUserInfo.organizationId)
            ) {
              // 主公司全部显示，分公司只显示该公司下的点
              let index = this.amap.vehicleMarker.findIndex(
                  (value) => value.licenseNo == val.data.licenseNo
              );
              if (index == -1) {
                this.drawVehicleMarker(val.data);
              } else {
                if (this.driverId == val.data.driverId) {
                  return;
                }
                let content = `<div class="vehicle-marker">${val.data.licenseNo} ${val.data.driverName}</div>`;
                let position = new AMap.LngLat(
                    val.data.location.longitude,
                    val.data.location.latitude
                );
                this.amap.vehicleMarker[index].setPosition(position);
                this.amap.vehicleMarker[index].setContent(content);
                this.amap.vehicleMarker[index].show();
              }
            }
          }
          break;
        case "Pay": // 支付
          if (this.autoRefresh == 1) {
            this.$refs.customTable.listFn();
          }
          break;
        case "Assign": // 指派
          this.$refs.customTable.listFn();
          break;
        case "Cancel": // 销单
          this.$refs.customTable.listFn();
          break;
        case "DriverStatus": // 司机状态变化
          if (Number(val.data.status) == 6) {
            // 司机状态为6表示退出登录
            this.driverStatus(val.data.driverId);
          }
          break;
        case "offline": // 司机下线
          this.driverStatus(val.data.driverId);
          break;
      }
    },
    async selectionRow(val) {
      if (val.length > 0) {
        this.loading = true;
        let row = val[0];
        this.shiftList = val.map((item) => {
          return item.schedulingId;
        });
        this.selectionNO = row.organizationId;
        this.organizationId = row.organizationId;

        this.ids = val.map((item) => {
          return item.id;
        });
        if (this.customOptions.params.status == "10") {
          //标记定位
          await this.getLineInfo();
          return;
        }
        // 清除司机车辆选中状态
        this.driverId = "";
        this.vehicleId = "";
        this.amap.vehicleMarker.forEach((item) => {
          let content = `<div class="vehicle-marker">${item.licenseNo} ${item.driverName}</div>`;
          item.setContent(content);
          item.setzIndex(100);
        });

        //标记定位
        await this.getLineInfo();
        //子表格
        this.visible = true;
        if (this.table.total == 0) {
          this.getVehicleList();
        } else {
          // 判断是不是有相同班次
          let data = JSON.parse(JSON.stringify(this.table.content));
          data.forEach((obj) => {
            obj.sameShift = false;
            if (obj.schedulingList) {
              obj.schedulingList.forEach((item) => {
                this.shiftList.forEach((shift) => {
                  if (item.schedulingId == shift) {
                    item.sort = 1;
                    obj.sameShift = true;
                    item.sameShift = true;
                  } else {
                    item.sort = 0;
                  }
                });
                obj.schedulingList.sort((a, b) => {
                  return b.sort - a.sort;
                });
              });
            }
          });

          data.forEach((obj) => {
            if (obj.sameShift) {
              obj.sort = 1;
            } else {
              obj.sort = 0;
            }
          });

          data.sort((a, b) => {
            return b.sort - a.sort;
          });

          this.table.content = data;
          this.$nextTick(() => {
            this.loading = false;
          });
        }
        this.$nextTick(() => {
          this.tableHeightFn();
        });
      } else {
        this.selectionNO = null;
        this.organizationId = null;
        this.closeClick();
        this.page = 1;
        this.table = {
          content: [],
          total: 0,
        };
        this.amap.markerBeginList.map((item) => {
          item.setMap(null);
        });
        this.amap.markerEndList.map((item) => {
          item.setMap(null);
        });
        this.amap.markerBeginList = [];
        this.amap.markerEndList = [];
        this.amap.markerBeginList = [];
        this.amap.markerEndList = [];
      }
    },
  },
  created() {
    this.mixinOrganizations();
    if (this.mixinUserInfo.organizationType != 1) {
      this.columns.splice(0, 1);
      this.columnsed.splice(0, 1);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
      this.getVehicleDriver();
      this.autoRefreshGet();
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    async autoRefreshGet() {
      let url = "/api/v1/manage/order/autoRefresh";
      let params = {organizationId: this.mixinUserInfo.organizationId}
      let data = await this.$axios.get(url, params);
      this.autoRefresh = data.data;
    },
    /* 修改实时刷新开关 */
    autoRefreshChange(event) {
      let tip = `${event == 1 ? '开启后' : '关闭后'}，有新订单时${event == 1 ? '会' : '不会'}自动刷新页面，确认要${event == 1 ? '开启' : '关闭'}吗？`
      this.$confirm(tip, "提示").then(async () => {
        let url = "/api/v1/manage/order/autoRefresh";
        let params = {
          organizationId: this.mixinUserInfo.organizationId,
          orderAutoRefresh: event
        }
        let data = await this.$axios.post(url, params);
        if (data && data.code == 1) {
          this.$message.success(event == 1 ? '已开启' : '已关闭');
          if (event == 1) {
            this.$refs.customTable.listFn();
          }
        }
      }).catch(() => {
        this.autoRefresh = event == 1 ? 2 : 1;
      });
    },
    /* 修改联系人电话 */
    async setCustomerPhone(row) {
      if (this.customerPhone.length != 11) {
        this.$message.info("请输入11位手机号");
        return;
      }
      let url = "/api/v1/manage/order/orderCustomer/updateCustomerPhone";
      let params = {
        orderId: row.id,
        customerPhone: this.customerPhone
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("已修改");
        row.customerPhone = this.customerPhone;
        this.visibleCustomerPhone = false;
      } else {
        this.$message.warning("修改失败");
      }
    },
    async onRowClick(val) {
      this.ids = [val.id];
      //标记定位
      await this.getLineInfo();
    },
    tableHeightFn() {
      let dispatchLeft = this.$refs.dispatchLeft.offsetHeight;
      let dispatchLeftTop = this.$refs.dispatchLeftTop.offsetHeight;
      let dialogTop = this.$refs.dialogTop.offsetHeight;
      let dialogTopSearch = this.$refs.dialogTopSearch.offsetHeight;
      this.tableHeight =
          dispatchLeft - dispatchLeftTop - dialogTop - dialogTopSearch - 90;
    },
    /**
     * 退票
     */
    async refund(row) {
      this.order = row;
      await this.getRefundFeeObj();
      if (!this.next) {
        return;
      }
      await this.getRefundRules();
      if (this.refundRules && this.refundRules.length > 0) {
        this.refundState = true;
      } else {
        this.$confirm("确认要取消本订单吗?", "退票提示").then(async () => {
          this.postCancel();
        });
      }
    },
    async cancelConfirm() {
      if (this.isCustomRule) {
        if (this.refundFee.trim() == '') {
          this.$message.warning({
            message: '请输入要扣除的费用'
          });
          return;
        }
      }
      this.loading = true;
      await this.postCancel();
      this.loading = false;
    },
    async getRefundRules() {
      let url = "/api/v1/manage/order/refund/" + this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundRules = data.data || [];
      }
    },
    async getRefundFeeObj() {
      let url = "/api/v1/manage/order/getRefundFee/" + this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundFeeObj = data.data || [];
        this.next = true;
      } else {
        this.next = false;
      }
    },
    async postCancel() {
      let params = {};
      if (this.isCustomRule) {
        params.refundFee = this.refundFee;
      }
      let url = "/api/v1/manage/order/cancel/" + this.order.id;
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("操作成功");
        this.$refs.customTable.listFn();
        this.refundState = false;
      }
    },
    /**
     * 显示订单详情
     */
    showOrderDetail(row) {
      this.currentOrderDetail = { ...row };
      this.orderDetailVisible = true;
    },
    /**
     * 地图初始化
     */
    initMap() {
      this.map = new AMap.Map("dispatch-map", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 11,
        center: new AMap.LngLat(104.065861, 30.657401),
      });
    },
    /**
     * 订单marker
     */
    drawOrderMarker() {
      this.amap.markerBeginList.map((item) => {
        item.setMap(null);
      });
      this.amap.markerEndList.map((item) => {
        item.setMap(null);
      });
      this.amap.markerBeginList = [];
      this.amap.markerEndList = [];
      this.lineInfo.map((item) => {
        let begin = item.address[0];
        let end = item.address[1];
        let beginContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;                                
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #4dace2;">
                                <div style="text-align:center;margin-bottom:5px;">${item.customerPhone}</div>
                                <div>上车地点：${begin.name}</div>
                            </div>`;
        let endContent = `<div  style="
                                padding: 10px;
                                justify-content: center;
                                align-items: center;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #FFFFFF;                                
                                box-shadow: 2px 2px 4px 0 rgba(0,0,0,0.30);
                                background-color: #47c147;">
                                <div style="text-align:center;margin-bottom:5px;">${item.customerPhone}</div>
                                <div>下车地点：${end.name}</div>
                          </div>`;

        if (begin.longitude) {
          let markerBegin = new AMap.Marker({
            position: new AMap.LngLat(begin.longitude, begin.latitude),
            icon: require("@/assets/img/markerBegin.png"),
            map: this.map,
          });
          markerBegin.setLabel({
            offset: new AMap.Pixel(0, -6),
            content: beginContent,
            direction: "top",
          });
          this.amap.markerBeginList.push(markerBegin);
        }

        if (end.longitude) {
          let markerEnd = new AMap.Marker({
            position: new AMap.LngLat(end.longitude, end.latitude),
            icon: require("@/assets/img/markerEnd.png"),
            map: this.map,
          });
          markerEnd.setLabel({
            offset: new AMap.Pixel(0, -6),
            content: endContent,
            direction: "top",
          });
          this.amap.markerEndList.push(markerEnd);
        }
      });

      this.map.setFitView([
        ...this.amap.markerBeginList,
        ...this.amap.markerEndList,
      ]);
    },
    /**
     * 车辆marker
     */
    drawVehicleMarker(item) {
      let that = this;
      let position = new AMap.LngLat(
          item.location.longitude,
          item.location.latitude
      );
      let content = `<div class="vehicle-marker">${item.licenseNo} ${item.driverName}</div>`;
      let marker = new AMap.Marker({
        // anchor: "bottom-center", // 设置锚点方位
        offset: new AMap.Pixel(1, -11),
        position: position, // 标记位置
        map: that.map, // 地图实例对象
        content: content,
      });
      marker.licenseNo = item.licenseNo;
      marker.driverName = item.driverName;
      marker.driverId = item.driverId;
      marker.on("click", function (e) {
        // this.map.setFitView();
        that.map.setCenter(e.lnglat);
        that.scrollFn(marker);
      });
      that.amap.vehicleMarker.push(marker);
      // this.map.setFitView();
    },
    scrollFn(marker) {
      if (this.table.content) {
        let index = this.table.content.findIndex(
            (item) => item.licenseNo == marker.licenseNo
        );
        if (index > -1) {
          this.chooseClick(this.table.content[index]);
          this.tableRowIndex = index;
          this.$nextTick(() => {
            this.$refs.tableList.bodyWrapper.scrollTop =
                document.getElementsByClassName("select-row")[0].offsetTop;
            this.timer = setTimeout(() => {
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.tableRowIndex = "";
            }, 2000);
          });
        }
      }
    },
    // 车辆列表选中样式
    tableRowClassName({rowIndex}) {
      if (rowIndex == this.tableRowIndex) {
        return "select-row";
      }
      return "";
    },
    // 排序改变
    sortFn(e) {
      if (e == 0) {
        delete this.customOptions.params.createdOrFinishTimeSort;
        this.customOptions.params.startLineTimeSort = 2;
      } else if (e == 1) {
        delete this.customOptions.params.createdOrFinishTimeSort;
        this.customOptions.params.startLineTimeSort = 1;
      } else if (e == 2) {
        delete this.customOptions.params.startLineTimeSort;
        this.customOptions.params.createdOrFinishTimeSort = 2;
      } else if (e == 3) {
        delete this.customOptions.params.startLineTimeSort;
        this.customOptions.params.createdOrFinishTimeSort = 1;
      }
      this.$refs.customTable.listFn();
    },
    /**
     * 状态改变
     */
    statusChange() {
      delete this.customOptions.params.assignTimeSort;
      if (this.customOptions.params.status == "10") {
        // 已指派订单
        this.$refs.customTable.toggleIndex = 0;
        this.customOptions.selection = false;
        this.customOptions.params.size = 20;
        delete this.customOptions.params.startLineTimeSort;
        this.customOptions.params.assignTimeSort = 2;
        this.closeClick();
      } else {
        this.$refs.customTable.toggleIndex = 1;
        this.customOptions.selection = true;
        this.customOptions.params.startLineTimeSort = 1;
        this.customOptions.params.size = 10;
      }

      this.amap.markerBeginList.map((item) => {
        item.setMap(null);
      });
      this.amap.markerEndList.map((item) => {
        item.setMap(null);
      });
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
    },
    // 查询
    queryFn() {
      this.$refs.customTable.listFn();
    },
    // 重置
    resetFn() {
      this.customOptions.params.organizationId = null;
      this.customOptions.params.lineName = null;
      this.customOptions.params.customerPhone = null;
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
      this.amap.vehicleMarker.forEach((item) => {
        item.hide();
      });

      this.amap.vehicleMarker = [];
      this.closeClick();
      this.getVehicleDriver();
    },

    /**
     * 切换车辆类型
     */
    async tabClick() {
      this.page = 1;
      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },
    async tabResetFn() {
      this.online = null;
      this.driverName = null;
      this.licenseNo = null;
      this.vehicleSeat = null;
      this.page = 1;
      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },
    /**
     * 获取订单所属线路信息
     */
    async getLineInfo() {
      let url =
          "/api/v1/manage/order/dispatch/queryStation/" + this.ids.join(",");
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.lineInfo = data.data || [];
        this.drawOrderMarker();
      }
    },
    vInfiniteScroll() {
      if (this.loading || this.noMore || this.table.total < this.size) {
        return;
      }
      this.getVehicleList();
    },
    /**
     * 车辆列表
     */
    async getVehicleList() {
      this.loading = true;
      let url = "/api/v1/manage/order/dispatch/queryVehicleList";
      let params = {
        page: this.page,
        size: this.size,
        status: this.online,
        vehicleSeat: this.vehicleSeat,
        driverName: this.driverName,
        licenseNo: this.licenseNo,
        organizationId: this.organizationId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code == 1) {
        // 判断是不是有相同班次
        data.data.forEach((obj) => {
          obj.sameShift = false;
          if (obj.schedulingList) {
            obj.schedulingList.forEach((item) => {
              this.shiftList.forEach((shift) => {
                if (item.schedulingId == shift) {
                  item.sort = 1;
                  obj.sameShift = true;
                  item.sameShift = true;
                } else {
                  item.sort = 0;
                }
              });
            });
            obj.schedulingList.sort((a, b) => {
              return b.sort - a.sort;
            });
          }
        });

        data.data.forEach((obj) => {
          if (obj.sameShift) {
            obj.sort = 1;
          } else {
            obj.sort = 0;
          }
        });

        data.data.sort((a, b) => {
          return b.sort - a.sort;
        });

        this.table = {
          content: data.data,
          total: data.total || 0,
        };
      }
      this.loading = false;
    },
    /**
     * 选择车辆司机
     */
    chooseClick(row) {
      if (row.seatStatus == 1 || row.seatStatus == 2) {
        return;
      }
      this.driverId = row.driverId;
      this.vehicleId = row.vehicleId;
      this.amap.vehicleMarker.forEach((item) => {
        if (item.driverId == this.driverId) {
          let content = `<div class="vehicle-marker choose">${row.licenseNo} ${row.driverName}</div>`;
          item.setContent(content);
          item.setzIndex(1000);
          let position = item.getPosition();
          this.map.setCenter(position);
        } else {
          let content = `<div class="vehicle-marker">${item.licenseNo} ${item.driverName}</div>`;
          item.setContent(content);
          item.setzIndex(100);
        }
      });
    },
    /**
     * 司机状态变化隐藏marker
     */
    driverStatus(driverId) {
      this.amap.vehicleMarker.forEach((item) => {
        if (item.driverId == driverId) {
          item.hide();
        }
      });
    },
    // 班次信息
    async lineVehicleListView(row) {
      row.schedulingList.forEach((item) => {
        item.xianlu = item.startStationName + " - " + item.endStationName;
        item.banci =
            this.$utils.timeFn(item.schedulingTime, "MM-DD") +
            " " +
            item.startTime +
            "-" +
            item.endTime;
      });
      this.viewData = row.schedulingList || [];
      this.viewTitle =
          row.licenseNo + " " + row.vehicleSeat + "座 " + row.driverName;
      this.viewVisible = true;
    },
    /**
     * 接口调用-指派
     */
    async dispatchClick() {
      if (this.selectionRow.length > 6) {
        this.$message.warning("最多同时勾选6条订单");
        return;
      }

      if (!this.vehicleId || !this.driverId) {
        this.$message.warning("请选择车辆");
        return;
      }
      this.dispatchLoading = true
      let url = "/api/v1/manage/order/dispatch/assign";
      let params = {
        [this.ids.length > 1 ? "orderIds" : "orderId"]:
            this.ids.length > 1 ? this.ids.join(",") : this.ids[0],
        driverId: this.driverId,
        vehicleId: this.vehicleId,
      };
      let data = await this.$axios.post(url, params);

      this.dispatchLoading = false
      if (data && data.code == 1) {
        this.$message.success("指派成功");
        this.customOptions.params.page = 1;
        this.$refs.customTable.listFn();
        this.closeClick();
      }
    },
    /* 关闭 */
    closeClick() {
      this.visible = false;
      this.$refs.customTable.$refs.tableInner.setCurrentRow();
    },
    /* 接口调用-获取附近车辆司机 */
    async getVehicleDriver() {
      let url = "/api/v1/manage/order/dispatch/ranges";
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        if (data.data && data.data.length > 0) {
          data.data.forEach((item) => {
            this.drawVehicleMarker(item);
          });
        }
      }
    },
  },

};
</script>

<style lang="less">
#dispatch {
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.05);
  display: flex;

  .custom-search-button {
    align-self: flex-end;
    padding: 0 !important;
  }

  .el-table__fixed-header-wrapper .el-checkbox {
    display: none;
  }

  .custom-search-top + div {
    margin-top: 8px !important;
  }

  .custom-action-operating {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    width: 50px;
    .el-button--text {
      padding: 0;
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
  }

  .dispatch-left {
    overflow: hidden;
    padding: 16px;
    flex: 1;
    min-width: 0;
    position: relative;
    display: flex;
    flex-direction: column;

    .dispatch-left-line {
      display: flex;
      align-items: center;
      font-weight: 600;
      position: absolute;
      right: 12px;
      top: 22px;

      .el-switch {
        margin: 0 16px;
      }

      .util-remark {
        font-weight: normal;
      }
    }
  }

  .el-tabs {
    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
  }

  .dispatch-map-wrapper {
    flex: 0 0 50%;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    background: #fff;
    margin: 16px 16px 16px 0;

    .dispatch-map-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px;
      border-bottom: 1px solid #e4e7ed;
      flex-shrink: 0;
      background: #fff;

      .dispatch-map-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        display: flex;
        align-items: center;
        gap: 6px;

        i {
          color: #409EFF;
          font-size: 16px;
        }
      }

      .dispatch-map-hint {
        font-size: 12px;
        color: #909399;
      }
    }

    #dispatch-map {
      flex: 1;
      min-height: 0;
    }
  }

  .vehicle-marker {
    // 车辆marker点样式
    background-color: #ff6600;
    padding: 0 10px;
    line-height: 30px;
    border-radius: 150px;
    white-space: nowrap;
    color: #fff;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: -16px;
      left: 50%;
      transform: translate(-50%, 0);
      border: 8px solid transparent;
      border-top-color: #ff6600;
    }
  }

  .vehicle-marker.choose {
    background-color: @color-primary;

    &:after {
      content: "";
      position: absolute;
      bottom: -16px;
      left: 50%;
      transform: translate(-50%, 0);
      border: 8px solid transparent;
      border-top-color: @color-primary;
    }
  }

  .amap-marker-label {
    background-color: @color-primary;
    color: #fff;
    border-color: transparent;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  }

  .order-marker-label {
    font-weight: 600;
  }

  .dispatch-assign {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    height: 400px;
  }

  .dispatch-vehicle {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    margin-top: 16px;

    .dialog-table {
      .infinite-scroll-table {
        /*margin-bottom: 12px;*/
        overflow-y: auto;
        height: 180px;
        /*&::-webkit-scrollbar {*/
        /*!*滚动条整体样式*!*/
        /*width: 0;  !*高宽分别对应横竖滚动条的尺寸*!*/
        /*!*width: 6px;  !*高宽分别对应横竖滚动条的尺寸*!*!*/
        /*height: 1px;*/
        /*}*/
        /*&::-webkit-scrollbar-thumb {*/
        /*!*滚动条里面小方块*!*/
        /*border-radius: 20px;*/
        /*box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
        /*background: #ccc;*/
        /*}*/
        /*&::-webkit-scrollbar-track {*/
        /*!*滚动条里面轨道*!*/
        /*box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);*/
        /*border-radius: 20px;*/
        /*background: #ededed;*/
        /*}*/
      }

      .table-head {
        th {
          border: 1px solid #ebeef5;
          border-bottom: none;
        }
      }

      ul {
        overflow-y: auto;
        height: 180px;
        list-style: none;

        li {
          min-height: 36px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          border: 1px solid #ebeef5;

          & > div {
            height: 100%;
            min-height: 36px;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            justify-content: center;
          }

          & > div:nth-child(1) {
            width: 110px;
            border-right: 1px solid #ebeef5;
          }

          & > div:nth-child(2) {
            width: 80px;
            border-right: 1px solid #ebeef5;
          }

          & > div:nth-child(3) {
            width: 221px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            border-right: 1px solid #ebeef5;
          }

          & > div:nth-child(4) {
            width: 95px;
          }
        }

        li + li {
          border-top: none;
        }
      }

      table {
        width: 100%;
        /*height: 100%;*/
        border-collapse: collapse;
        color: #606266;
        /*position: relative;*/
        /*thead {*/
        /*position: absolute;*/
        /*}*/

        tr {
          /*display: inline-block;*/
          height: 36px;
          line-height: 36px;
        }

        th {
          background-color: #fafafa;
          color: #909399;
          font-weight: 600;
        }

        td {
          border: 1px solid #ebeef5;
        }

        th,
        td {
          padding: 0 10px;
          box-sizing: border-box;
          text-align: left;
        }

        tr:nth-child(2n) {
          background: #fafafa;
        }

        .no-data {
          text-align: center;
          color: #999;
          background-color: #fff;
        }

        .no-more {
          text-align: center;
          color: #999;
          border: none;
          background-color: #fff;
        }

        th:nth-child(1),
        td:nth-child(1) {
          width: 130px;
        }

        th:nth-child(2),
        td:nth-child(2) {
          width: 80px;
        }

        th:nth-child(3),
        td:nth-child(3) {
          width: 330px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .p-infinite-scroll {
        text-align: center;
      }
    }

    .dialog-line-list {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 20px;
    }

    .el-dialog__body {
      padding-top: 10px;
    }

    .dialog-top {
      display: flex;
      line-height: 28px;
      font-size: 14px;
      margin-bottom: 2px;

      .dialog-top-item + .dialog-top-item {
        margin-left: 16px;
      }

      .line-name {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .select-row {
    background: rgba(2, 136, 255, 0.3);
  }

  .cancel-money {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-of-type {
      border-bottom: none;
    }

    .cancel-money-title {
      font-weight: 500;
      color: #606266;
    }

    .cancel-money-money {
      font-weight: 600;
      font-size: 16px;
    }

    .util-money {
      padding-left: 8px;
      color: #F56C6C;
      font-weight: 600;
    }
  }

  .cancel-money + .cancel-money {
    padding-top: 12px;
  }
  
  // 弹窗样式
  .el-dialog {
    border-radius: 8px;
    
    .el-dialog__header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      
      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-dialog__footer {
      padding: 12px 20px;
      border-top: 1px solid #ebeef5;
      
      .el-button {
        border-radius: 6px;
      }
    }
  }
  
  // Tab样式
  .el-tabs {
    .el-tabs__item {
      &.is-active {
        color: #2B77FF;
        font-weight: 500;
      }
    }
    
    .el-tabs__active-bar {
      background-color: #2B77FF;
    }
  }
}

.el-popover + .el-popover {
  display: none !important;
}
</style>
